import { useQueryWhenAuthenticated } from 'hooks';
import { UserRecentSearches } from 'types/generated/graphql';
import { GetUserRecentSearch } from './userRecentSearch.gql';

const fallbackRecentSearch = {
    getUserRecentSearch: {
        recentSearch: [],
    },
};

const useGetUserRecentSearches = () => {
    const { data = fallbackRecentSearch } = useQueryWhenAuthenticated<{
        getUserRecentSearch: UserRecentSearches;
    }>({
        query: GetUserRecentSearch,
    });

    return data?.getUserRecentSearch?.recentSearch;
};

export default useGetUserRecentSearches;
